import { render, staticRenderFns } from "./ListingsPage.vue?vue&type=template&id=bc84d744&lang=pug&"
import script from "./ListingsPage.vue?vue&type=script&lang=js&"
export * from "./ListingsPage.vue?vue&type=script&lang=js&"
import style0 from "./ListingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports